import { StackActions } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { RootStackParamList, ResourceTypes } from '~/client/NavigationConfig';
import logger from '~/client/utils/logger';

import { UrlTypes } from '~/client/utils/constants';

// songs, albums and playlists are always pushed as a new screen rather than
// `navigate`d to. `navigate` reuses a screen of the same type that's already
// in the stack, jumping back to it and dropping everything after it, so after
// e.g. song -> album -> another song, the back button skipped the album and
// left the app.

export default function navigateToResource({
  navigation,
  resourceType,
  resourceId,
}: {
  navigation: NativeStackNavigationProp<RootStackParamList, ResourceTypes>;
  resourceType: string;
  resourceId: string;
}): void {
  if (resourceType === UrlTypes.song) {
    return navigation.push('Song', {
      resourceId,
    });
  } else if (resourceType === UrlTypes.album) {
    return navigation.push('Album', {
      resourceId,
    });
  } else if (resourceType === UrlTypes.playlist) {
    return navigation.push('Playlist', {
      resourceId,
    });
  }

  logger.error('Navigation to resource failed. This should never happen.', {
    resourceType,
    resourceId,
  });

  return navigation.navigate('Home');
}

// props for a <Link> to a song, album or playlist: `to` gives the link its
// URL, and `action` pushes a new screen when it's tapped.
export function resourceLinkProps(
  resourceType: ResourceTypes,
  resourceId: string | number,
) {
  const params = { resourceId: String(resourceId) };
  return {
    to: { screen: resourceType, params },
    action: StackActions.push(resourceType, params),
  };
}
